import { HttpStatusCode } from "axios";
import { z } from "zod";

const BaseErrorWithStatusCodeResponseSchema = z.object({
	statusCode: z.nativeEnum(HttpStatusCode),
	body: z.object({
		error: z.object({
			code: z.string(),
			message: z.string(),
			detail: z.string(),
		}),
	}),
});

const BaseErrorResponseSchema = z.object({
	error: z.object({
		code: z.string(),
		message: z.string(),
		detail: z.string(),
	}),
});

export const GenericErrorResponseSchema = z.union([
	BaseErrorWithStatusCodeResponseSchema.transform(({ body: { error } }) => ({
		error,
	})),
	BaseErrorResponseSchema,
]);
